/**
 * A name's possessive: "Example Dental" -> "Example Dental's", and a name
 * ending in s takes the apostrophe alone: "Example Architects" -> "Example
 * Architects'" (the wiki review, 2026-10-19). Nothing to own gives nothing.
 * The server's own text does the same (app/domain/possessive.py).
 */
export function possessive(name: string): string {
  if (!name) {
    return "";
  }
  return /s$/i.test(name) ? `${name}'` : `${name}'s`;
}
